import * as types from '../../Types';
import { getHeader } from '../../ConfigureStore';

export const LOGIN_API_URL = 'login';

export function login(authData) {
  return {
    types: [types.LOGIN, types.LOGIN_SUCCESS, types.LOGIN_FAILURE],
    payload: {
      authData
    },
    promise: client => {
      const { accessToken, provider } = authData;
      const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const loginUrl =
        provider === 'google'
          ? LOGIN_API_URL
          : `${baseUrl.split('api/')[0]}api/v2/${LOGIN_API_URL}`;

      return client
        .post(loginUrl, { ...authData, provider }, getHeader(accessToken, provider))
        .catch(error => {
          console.error('Login error:', error.stack);
          const message =
            error.response?.data?.message ||
            'Error occurred while processing your request. Please try again later.';
          throw new Error(message);
        });
    }
  };
}

export function logout() {
  return {
    type: types.CLEAR_AUTH_DATA
  };
}
export function destroyAuthSession() {
  return {
    type: types.DESTROY_AUTH_SESSION
  };
}
export function destroySession() {
  return {
    type: types.DESTROY_SESSION
  };
}
